import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const QuestionViewLazy = React.lazy(
	() => import(/* webpackChunkName : 'QuestionView' */ './components')
);

export default () => {
	return {
		path: ':view/:questionId?',
		element: <AsyncLoading component={<QuestionViewLazy />} />,
	};
};
